<template>
  <div class="homePage">
    <div class="fiex" :style="{ top: menuTop + 'px' }">
      <Navigation :active="2"></Navigation>
    </div>
    <div class="right">
      <div class="screen-box">
        <div class="input-box">
          <div class="title">{{ $t("common.taskRecord.participationYear") }}</div>
          <el-date-picker
            v-model="year"
            type="year"
            value-format="yyyy"
            :placeholder="$t('common.taskRecord.selectYear')"
          >
          </el-date-picker>
        </div>

        <div class="input-box">
          <div class="title">{{ $t("common.taskRecord.questionnaireName") }}</div>
          <el-input
            v-model="title"
            :placeholder="$t('module.taskRecord.title6')"
          >
          </el-input>
        </div>
        <div class="input-box">
          <div class="title">{{ $t("common.taskRecord.taskNumber") }}</div>
          <el-input
            v-model="number"
            :placeholder="$t('module.taskRecord.title6')"
          >
          </el-input>
        </div>

        <button class="screen-btn" @click="gethistoricalSurveys(1)">
          <i class="el-icon-refresh-right refresh" v-if="flagpc"></i>
          {{ $t("module.taskRecord.title8") }}
        </button>
      </div>

      <div class="screen-box2">
        <div class="left">
          <el-date-picker
            v-model="year2"
            type="year"
            value-format="yyyy"
            :placeholder="$t('common.taskRecord.selectYear')"
            @change="gethistoricalSurveys2(1)"
          >
          </el-date-picker>
        </div>
        <div class="input-box">
          <input v-model="title2" :placeholder="$t('common.taskRecord.questionnaireName')" />
          <img
            @click="gethistoricalSurveys2(1)"
            src="@/assets/image/module/search.png"
          />
        </div>
      </div>

      <div class="list-box" ref="scrollContainer" @scroll="handleScroll">
        <div class="list-item" v-for="(item, index) in tableData2" :key="index">
          <div class="line-box">
            <div class="title">{{ $t("module.taskRecord.title9") }}</div>
            <div class="content">{{ item.number }}</div>
          </div>
          <div class="line-box">
            <div class="title">{{ $t("module.taskRecord.title10") }}</div>
            <div class="content">{{ item.title }}</div>
          </div>
          <div class="line-box">
            <div class="title">{{ $t("module.taskRecord.title11") }}</div>
            <div class="content">{{ item.joinDate | dateFrom }}</div>
          </div>
          <div class="line-box">
            <div class="title">{{ $t("module.taskRecord.title12") }}</div>
            <div class="content color1">10</div>
          </div>
          <div class="line-box">
            <div class="title">{{ $t("module.taskRecord.title13") }}</div>
            <div class="content color2">
              <div class="participationStatus" v-if="item.state === 0">
                <span style="background-color: #1890ff"></span>
                {{ $t("common.taskRecord.exitedMidway") }}
              </div>
              <div class="participationStatus" v-if="item.state === 1">
                <span style="background-color: #d48806"></span>
                {{ $t("common.taskRecord.screenedOut") }}
              </div>
              <div class="participationStatus" v-if="item.state === 2">
                <span style="background-color: #595959"></span>
                {{ $t("common.taskRecord.quotaFull") }}
              </div>
              <div class="participationStatus" v-if="item.state === 3">
                <span style="background-color: #389e0d"></span>
                {{ $t("common.taskRecord.completedSuccessfully") }}
              </div>
              <div class="participationStatus" v-if="item.state === 4">
                <span style="background-color: #cf1322"></span>
                {{ $t("common.taskRecord.auditRejected") }}
              </div>
              <div class="participationStatus" v-if="item.state === 8">
                <span style="background-color: #d4b106"></span>
                {{ $t("common.taskRecord.qualityScreening") }}
              </div>
            </div>
          </div>
          <div class="line-box">
            <div class="title">{{ $t("common.taskRecord.returnTime") }}</div>
            <div class="content color3">{{ item.returnDate | dateFrom }}</div>
          </div>
        </div>

        <div class="flag" v-if="!flag && tableData2.length !== 0">
          {{ $t("common.taskRecord.loadMore") }}
        </div>
        <div class="flag" v-if="flag && tableData2.length !== 0">
          {{ $t("common.taskRecord.noMoreData") }}
        </div>

        <el-empty
          v-if="tableData2.length === 0"
          :description="$t('common.taskRecord.noData')"
        ></el-empty>
      </div>

      <div class="table-box">
        <el-table :data="tableData" height="880" border style="width: 100%">
          <el-table-column
            prop="number"
            :label="$t('module.taskRecord.title9')"
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="title"
            :label="$t('module.taskRecord.title10')"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            prop="date"
            :label="$t('module.taskRecord.title11')"
            width="150"
          >
            >
            <template slot-scope="scope">
              {{ scope.row.joinDate | dateFrom }}
            </template>
          </el-table-column>
          <el-table-column
            prop="actualPoints"
            :label="$t('module.taskRecord.title12')"
          width="120"
          >
          </el-table-column>
          <el-table-column prop="participationStatus" :label="$t('common.taskRecord.status')" width="120">
            <template slot-scope="scope">
              <div class="participationStatus" v-if="scope.row.state === 0">
                <span style="background-color: #1890ff"></span>
                {{ $t("common.taskRecord.exitedMidway") }}
              </div>
              <div class="participationStatus" v-if="scope.row.state === 1">
                <span style="background-color: #d48806"></span>
                {{ $t("common.taskRecord.screenedOut") }}
              </div>
              <div class="participationStatus" v-if="scope.row.state === 2">
                <span style="background-color: #595959"></span>
                {{ $t("common.taskRecord.quotaFull") }}
              </div>
              <div class="participationStatus" v-if="scope.row.state === 3">
                <span style="background-color: #389e0d"></span>
                {{ $t("common.taskRecord.completedSuccessfully") }}
              </div>
              <div class="participationStatus" v-if="scope.row.state === 4">
                <span style="background-color: #cf1322"></span>
                {{ $t("common.taskRecord.auditRejected") }}
              </div>
              <div class="participationStatus" v-if="scope.row.state === 8">
                <span style="background-color: #d4b106"></span>
                {{ $t("common.taskRecord.qualityScreening") }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="Auditing" :label="$t('common.taskRecord.returnTime')" width="150">
            <template slot-scope="scope">
              {{ scope.row.returnDate | dateFrom }}
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-box">
          <el-pagination
            @size-change="gethistoricalSurveys(1)"
            @current-change="gethistoricalSurveys"
            :current-page="page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size.sync="size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Navigation from "@/components/Navigation/side";
import { gethistoricalSurveys } from "@/api/user";
export default {
  filters: {
    dateFrom(data) {
      if (data) {
        const date = new Date(data);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份是从0开始的
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        return `${year}-${month}-${day} ${hours}:${minutes}`;
      } else {
        return "";
      }
    },
  },
  data() {
    return {
      value1: null,
      value2: null,
      value3: null,
      menuTop: 86,
      options: [
        {
          value: 1,
          label: "已完成",
        },
        {
          value: 2,
          label: "未完成",
        },
        {
          value: 3,
          label: "其它",
        },
      ],
      options2: [
        {
          value: 1,
          label: "已审核",
        },
        {
          value: 2,
          label: "待审核",
        },
        {
          value: 3,
          label: "其它",
        },
      ],
      tableData: [],
      tableData2: [],
      currentPage: 1,

      page: 1,
      size: 10,
      total: 0,
      year: null,
      title: null,

      page2: 1,
      size2: 10,
      year2: null,
      title2: null,

      flag: false,
      number: null,
      flagpc: false,
    };
  },
  components: { Navigation },
  methods: {
    listenScroll() {
      console.log(
        "1111",
        document.body.offsetHeight - document.scrollingElement.scrollTop,
        window.innerHeight
      );
      if (
        document.body.offsetHeight - document.scrollingElement.scrollTop <=
        845
      ) {
        this.menuTop =
          document.body.offsetHeight -
          document.scrollingElement.scrollTop -
          815; //，添加el-menu-item,增加730的数值,减少707相同数值
      } else {
        this.menuTop = 86;
      }
    },

    gethistoricalSurveys(type) {
      if (this.flagpc) {
        return;
      }
      if (type) {
        this.page = type;
      }
      this.flagpc = true;
      gethistoricalSurveys({
        page: this.page,
        size: this.size,
        year: this.year,
        title: this.title,
        number: this.number,
      })
        .then((res) => {
          this.flagpc = false;
          if (res.code === 200) {
            this.tableData = res.data.list;
            this.total = res.data.dataCount;
          }
        })
        .catch(() => {
          this.flagpc = false;
        });
    },

    gethistoricalSurveys2(type) {
      if (type) {
        this.page2 = type;
        this.flag = false;
        this.tableData2 = [];
      }

      if (this.flag) {
        return;
      }
      gethistoricalSurveys({
        page: this.page2,
        size: this.size2,
        year: this.year2,
        title: this.title2,
      }).then((res) => {
        if (res.code === 200) {
          if (res.data.list.length > 0) {
            this.tableData2 = this.tableData2.concat(res.data.list);
            if (res.data.list.length === 10) {
              this.page2++;
            } else {
              this.flag = true;
            }
          }
        }
      });
    },

    handleScroll(e) {
      const container = this.$refs.scrollContainer;
      // 检查是否接近底部
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - 1
      ) {
        // 触底逻辑，例如加载更多数据
        console.log("触底");
        this.gethistoricalSurveys2();
      }
    },
  },
  created() {
    // this.year = new Date().getFullYear();
    console.log(
      "new Date().getFullYear()",
      new Date().getFullYear().toString()
    );
    this.year = new Date().getFullYear().toString();
    this.year2 = new Date().getFullYear().toString();
    window.addEventListener("scroll", this.listenScroll);
    this.gethistoricalSurveys();
    this.gethistoricalSurveys2();
  },
  mounted() {},
  destroyed() {
    window.removeEventListener("scroll", this.listenScroll);
  },
};
</script>

<style lang="scss" scoped>
.homePage {
  min-height: 500px;
  display: flex;
  justify-content: flex-end;
  .fiex {
    position: fixed;
    left: 140px;
    transition: top ease 0.1s;
  }
  .right {
    flex-shrink: 0;
    width: calc(100% - 480px);
    margin-right: 140px;
    padding-top: 16px;
  }
}

//筛选
.screen-box {
  display: flex;
  padding: 20px 0 0 25px;
  background-color: #fff;
  flex-wrap: wrap;
  .input-box {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    margin-right: 25px;
    .title {
      color: #333333;
      font-size: 14px;
      font-weight: bolder;
      margin-right: 15px;
      flex-shrink: 0;
    }
    .el-select {
      width: 150px;
    }
    .el-input {
      width: 150px;
    }
  }
  .screen-btn {
    cursor: pointer;
    margin-right: 25px;
    margin-bottom: 20px;
    border: none;
    color: #fff;
    padding: 0;
    width: 76px;
    height: 32px;
    background: linear-gradient(141deg, #a896ff 0%, #8b4eff 100%);
    box-shadow: 0px 3px 15px 1px rgba(137, 72, 255, 0.4);
    border-radius: 16px 16px 16px 16px;
  }
}
//表格
.table-box {
  margin-top: 16px;
  height: 960px;
  margin-bottom: 24px;
  background-color: #fff;
  .pagination-box {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
    margin-right: 25px;
  }
}
.participationStatus {
  color: #474f66;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    width: 7px;
    height: 7px;
    border-radius: 3.5px;
    margin-right: 10px;
  }
}
.Auditing {
  color: #8948ff;
}

//筛选移动端
.screen-box2 {
  display: none;
  justify-content: space-between;
  align-items: center;
  .left {
    display: flex;
    .el-date-editor {
      width: 130px;
      margin-right: 10px;
    }
  }
  .input-box {
    position: relative;
    input {
      width: 150px;
      height: 40px;
      background: #ffffff;
      border-radius: 20px 20px 20px 20px;
      padding: 0;
      border: none;
      padding: 0 42px 0 12px;
      outline: none;
      box-sizing: border-box;
    }
    img {
      position: absolute;
      right: 12px;
      width: 20px;
      height: 20px;
      top: 8px;
    }
  }
}

//列表移动端
.list-box {
  display: none;
  max-height: 500px;
  overflow: auto;
  margin-top: 15px;
  margin-bottom: 25px;
  .list-item {
    width: 100%;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    margin-bottom: 10px;
    padding: 17px 0;
    .line-box {
      padding: 0 15px 0 10px;
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      color: #232323;
      margin-bottom: 12px;
      .title {
        font-size: 14px;
        color: #232323;
      }
      .color1 {
        font-size: 18px;
        color: #8846ff;
        font-weight: bolder;
      }
      .color2 {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #474f66;
        span {
          width: 7px;
          height: 7px;
          background: #ff6026;
          border-radius: 3.5px;
          margin-right: 10px;
        }
      }
      .color3 {
        font-size: 14px;
        color: #8846ff;
      }
    }
  }
  .flag {
    text-align: center;
    color: #999;
    font-size: 14px;
  }
}
</style>
<style scoped>
.table-box >>> .el-table__header .el-table__cell {
  background-color: #fafbfc;
  color: #474f66;
  font-size: 14px;
  font-weight: bolder;
  text-align: center;
}
.table-box >>> .el-table__body .el-table__cell {
  text-align: center;
  color: #474f66;
  font-size: 14px;
}
</style>
<style lang="scss" scoped>
/* 媒体查询 */
@media only screen and (max-width: 1400px) {
  .homePage {
    .fiex {
      left: 70px;
    }
    .right {
      flex-shrink: 0;
      width: calc(100% - 340px);
      margin-right: 70px;
    }
  }
}

@media only screen and (max-width: 1300px) {
  .homePage {
    .fiex {
      left: 30px;
    }
    .right {
      flex-shrink: 0;
      width: calc(100% - 260px);
      margin-right: 30px;
    }
  }
}

@media only screen and (max-width: 1200px) {
  .homePage {
    .fiex {
      left: 30px;
    }
    .right {
      flex-shrink: 0;
      width: calc(100% - 260px);
      margin-right: 30px;
      .sign-box {
        flex-direction: column;
        .sign {
          width: 100%;
        }
      }
    }
  }
}

@media only screen and (max-width: 1000px) {
  .homePage {
    .fiex {
      display: none;
    }
    .right {
      width: calc(100% - 30px);
      margin-right: 15px;
    }
  }
}

@media only screen and (max-width: 750px) {
  .homePage {
    .screen-box {
      display: none;
    }
    .table-box {
      display: none;
    }
    //筛选移动端
    .screen-box2 {
      display: flex;
    }
    .list-box {
      display: block;
    }
  }
}
</style>

<style scoped>
.refresh {
  -webkit-animation: rotate 1s linear infinite;
  -moz-animation: rotate 1s linear infinite;
  -o-animation: rotate 1s linear infinite;
  animation: rotate 1s linear infinite;
}
@-webkit-keyframes rotate {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}
@-moz-keyframes rotate {
  from {
    -moz-transform: rotate(0deg);
  }
  to {
    -moz-transform: rotate(359deg);
  }
}
@-o-keyframes rotate {
  from {
    -o-transform: rotate(0deg);
  }
  to {
    -o-transform: rotate(359deg);
  }
}
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
</style>